<template>
    <div>
        <div class="reqrefundBox">
            <div class="reqrefundTit">自助退款</div>
            <div class="reqrefundTitTip">（退款到账时间工作日下午6点之前，节假日顺延）</div>
            <div class="reqrefundInfo">
                <div class="infoItem infoOne">
                    <div class="infoLfet">
                        <div class="ItemTit">所属产品：</div>
                        <div class="itemBt">Runway 视频</div>
                    </div>
                    <div class="inforght">会员ID：{{ userInfo.uid }}</div>
                </div>
                <div class="infoItem infoThr">
                    <div class="ItemTit">支付金额：</div>
                    <div class="itemTex itemTexOne">{{ reqFundInfo.pay_money / 100 }} 元</div>
                </div>
                <div class="infoItem infoTwo">
                    <div class="infoLfet">
                        <div class="ItemTit">会员时长：</div>
                        <div class="itemTex itemTexTwo">{{ reqFundInfo.vip_use_day ? reqFundInfo.vip_use_day : 0 }} 天</div>
                    </div>
                    <!-- <div class="inforght itemTexTwoOth">注册时间：{{ formatTimestamp(reqFundInfo.refund_req_time)}}</div> -->
                </div>
                <div class="seveText">7天内无理由退款，不扣除费用，超过按照1.5元/天扣除</div>
                <div class="infoItem">
                    <div class="ItemTit">创作次数：</div>
                    <div class="itemTex itemTexThr">{{ reqFundInfo.use_num }} 次 <span
                            class="itemTexTwoOth">（单次扣除费用5元/次）</span></div>
                </div>
                <div class="infoItem intoIemOth">
                    <div class="ItemTit">可退费用：</div>
                    <div class="itemTex">{{ reqFundInfo.pay_money / 100 }} {{
                        reqFundInfo.vip_use_day >= 7 ? `-${reqFundInfo.vip_use_day}*1.5`:``}} - {{ reqFundInfo.use_num }}*5
                        = <span class="resText">{{ getRefundMoney() / 100 }}</span> <span class="resOth">元</span> </div>
                </div>
                <div class="infoItem">
                    <div class="ItemTit">退款原因：</div>
                    <textarea v-model="reqreText" class="reqreTextare" placeholder="必填"></textarea>
                </div>
            </div>
            <div class="reqreBtn" @click="toReqreFun">
                同意并申请退款
            </div>
            <div class="reqTipText">（退款到账时间工作日下午六点之前，节假日顺延）</div>
            <div class="reqTimeBox">
                问：会员时长是如何计算？
                <div class="anText">答：是从您最后一次成功支付的订单时间截止到当前的会员时长计算，不是从注册时间开始算！</div>
                <div class="quBottom"></div>
                问：使用次数如何计算？
                <div class="anText">答：是从您成功支付后使用产品的次数开始算，免费会员的免费试用次数不计算在内！</div>
            </div>
        </div>

        <div class="reqrePopBox" v-show="reqrePopBoxshow">
            <div class="reqSuccessBox" v-if="isReqStatu">
                <img :src="isSuccess ? '/static/img/reqSuccess.png' : '/static/img/reqError.png'" class="reqSuccessImg"
                    alt="">
                <div :class="isSuccess ? 'reqSucText' : 'reqSucText reqSucTextOth'">
                    {{ isSuccess ? '自助退款申请成功' : '您已经申请过退款,请勿重复申请' }}</div>
                <div class="reqSucTip">退款到账时间工作日下午6点之前，节假日顺延</div>
                <div class="closeBtn" @click="closePop">关闭页面</div>
            </div>
            <div class="instructions_box" v-if="xiyi">
                <p>退款须知</p>
                <div>
                    尊敬的客户：
                </div>
                <div class="ft_i2">
                    本产品属虚拟会员服务，含数字内容访问权、
                    专属功能使用权等非实体权益，依法不适用七天
                    无理由退款规定‌，秉承用户至上理念，特开通退
                    款申请通道：
                </div>
                <div class="ft_i2 color_11">
                    7天内未使用本产品，全额退款！
                </div>
                <div class="ft_i2 color_r">
                    已使用：扣除会员天数 + 产品使用次数的费用
                </div>
                <div class="subBtn1" @click="guide('关闭')">
                    好的，我知道了
                </div>
            </div>
            <div class="reqSuccessBox reqSuccessBoxOth" v-else-if="nullOrder">
                <img src="/static/img/reqError.png" class="reqSuccessImg" alt="">
                <div class="reqSucText reqSucTextOth">暂无查到订单信息 ，无法申请退款</div>
                <div class="noOrderBox">
                    <div class="noOrderText">可能引起的原因如下：</div>
                    <div class="noOrderText">
                        一、当前是微信登录，订单可能在账号内支付，<span class="color_11"
                            @click="isCheckLogin = true">点此切换账号登录查询</span>
                    </div>
                    <div class="noOrderText">
                        二、您可能在其他冒充我们的虚假平台支付，请把订单截图<span class="color_11" @click="toKF">点此联系并发给客服</span>再次确认！
                    </div>
                </div>
                <!-- <div class="reqSucTip">退款到账时间工作日下午6点之前，节假日顺延</div> -->
                <div class="closeBtn" @click="closePop">关闭页面</div>
            </div>


        </div>

        <div class="reqrePopBox" v-if="isCheckLogin">
            <div class="LoginPanel">
                <img class="closeChechLogin" src="/static/img/icon-close.png" alt="" @click="closeLoginPop">
                <div class="LoginBox">
                    <div class="logTit">切换账号登录</div>
                    <div style="position: relative" v-if="LogionSwitch">
                        <img class="saoImg" v-if="LogionSwitch" :src="code_img_url" alt="">
                        <div v-if="timerout" class="time_out_cover" flex-center @click="get_login_code"> 二维码已过期，点击刷新
                        </div>
                    </div>
                    <div class="account" v-if="!LogionSwitch"><input v-model="form.phone" type="text"
                            placeholder="请输入账号">
                    </div>
                    <div class="cipher" v-if="!LogionSwitch"><input v-model="form.password" type="password"
                            placeholder="请输入密码"></div>
                    <div :class="isWeixin ? 'loginBtn loginTipTexOths' : 'loginBtn'" v-if="!LogionSwitch" @click="login()">
                        登录</div>
                    <div class="loginTipTex " v-if="LogionSwitch">微信登录扫码</div>
                    <div class="loginTipTex LoginOth" v-show="!isWeixin">或</div>
                    <div class="loginTipTex LoginBlu" @click="toLogion()" v-show="!isWeixin">点此{{ LogionSwitch ? '账号密码'
                        : '微信扫码' }}登录
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../utils';

export default {
    data() {
        return {
            isReq: true,
            reqFundInfo: {
                id: 0,
                pay_date: 0,
                pay_money: 0,
                refund_money: 0,
                refund_remark: 0,
                refund_req_time: 0,
                refund_time: 0,
                use_num: 0,
                vip_use_day: 0
            },
            form: {
                phone: "",
                code: "",
                password: "",
                password2: ""
            },
            code_img_url: null,
            reqrePopBoxshow: false,
            isSuccess: false,
            // isLogin:false,
            xiyi: true,
            isReqStatu: false,
            reqreText: '',
            timer: null,
            nullOrder: false,
            LoginPanel: null,
            LogionSwitch: false,
            isWeixin: false,
            timerout: false,
            str_uuid: 0,
            isCheckLogin: false
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        isLogin() {
            return this.$store.state.isLogin;
        },
    },
    mounted() {
        var ua = navigator.userAgent.toLowerCase();
        if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
            this.isWeixin = true
        } else {
            this.isWeixin = false
        }
        let invite_code = localStorage.getItem("invite_code") || "";
        this.$http.get(`/front/user/profile/`, {
            params: {
                invite_code: invite_code,
                app_id: APP_ID
            }
        }).then(res => {
            if (res.status == '200') {
                clearInterval(this.timer)
                this.getRefundInfo()
            }
        }).catch(err => {
            if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
                localStorage.setItem('isREQre', true)
                window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
                this.$store.state.show_login_compoments = false
                return
            } else {
                if (!localStorage.getItem('user_id')) {
                    this.$store.state.show_login_compoments = true
                }
            }
            this.timer = setInterval(() => {
                let tok = localStorage.getItem('token')
                if (tok) {
                    clearInterval(this.timer)
                    this.getRefundInfo()
                }
            }, 1000);
        })
    },
    methods: {
        closeLoginPop(){
            this.isCheckLogin = false
            clearInterval(this.timer)
        },
        clearFn() {
            clearInterval(this.timer)
            this.isCheckLogin = false
            this.reqrePopBoxshow = false
            this.isReqStatu = false
            this.xiyi = false
            this.nullOrder = false
        },
        login() {//登录

            let data = {
                phone: this.form.phone,
                password: this.form.password
            }
            this.$http.post('/front/auth/login/phone/', data).then(res => {
                if (res.status == '200') {
                    this.$message({
                        message: '登录成功！',
                        type: 'success'
                    });
                    localStorage.setItem("token", res.data.token);
                    this.clearFn();
                    this.getProfile();
                    // this.$refs.LoginPanel.close()
                    //重新刷新页面
                } else {
                    console.log(res.message)
                    this.$message({
                        message: res.message,
                        type: 'warning',
                    })
                }
            }).catch(res => {
                console.log(2222)
                this.$message({
                    message: res.message,
                    type: 'warning'
                });
                this.clearFn();
            })
        },
        getProfile() {
            // 获取用户信息
            this.$http.get(`/front/user/profile/`, {
                params: {
                    app_id: APP_ID
                }
            }).then(res => {
                if (res.status == '200') {
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setIsLogin', true)
                    this.$store.commit('setShowLogin', false)
                    this.clearFn()
                    this.getRefundInfo()
                }
            }).catch(err => {
                // 没有获取 登录弹窗
                this.get_login_code()
            })
        },
        get_login_code() {
            this.timerout = false
            this.pay_time = 0
            if (this.timer) {
                clearInterval(this.timer)
            }
            let bd_vid = localStorage.getItem("bd_vid") || "";
            let qhclickid = localStorage.getItem("qhclickid") || "";
            let sourceid = localStorage.getItem("sourceid") || "";
            let href = location.href
            let ad_account_id = localStorage.getItem("ad_account_id") || 0;
            let site_id = localStorage.getItem("site_id") || 0;
            let timestamp = localStorage.getItem("timestamp") || 0;
            if (href.indexOf(API_SERVER) <= -1) {
                ad_account_id = ad_account_id || AD_AID
            }
            let keyword = localStorage.getItem("keyword") || "";
            let params = { ad_account_id: ad_account_id, site_id: site_id, keyword: keyword, bd_vid: bd_vid, qhclickid: qhclickid, sourceid: sourceid, timestamp: timestamp }
            this.$http.get(`/front/wx/imagecode/?authorizer_appid=${APP_ID}`, params).then(res => {
                if (res.status == '200') {
                    this.code_img_url = res.data.res_img
                    this.str_uuid = res.data.str_uuid;
                    this.getLoginInfo();
                }
            })
        },
        getLoginInfo() {
            this.timerout = false
            this.timer = setInterval(() => {
                let href = location.href
                let ad_account_id = this.getCache("ad_account_id") || 0
                let site_id = this.getCache("site_id") || 0
                let keyword = this.getCache("keyword") || ""
                let timestamp = localStorage.getItem("timestamp") || 0;

                if (href.indexOf(API_SERVER) <= -1) {
                    ad_account_id = ad_account_id || AD_AID
                }
                let params = { str_uuid: this.str_uuid, ad_account_id: ad_account_id, site_id: site_id, keyword: keyword, timestamp: timestamp }
                this.$http.get(`/front/wx/imagecodelogin/`, { params: params }).then((res) => {
                    if (res.data.is_auth_wxa == 1 && res.data.user_id && res.data.token) {
                        localStorage.setItem("token", res.data.token);
                        this.getProfile();
                        clearInterval(this.timer);
                        this.timer = null
                    }
                })
                this.pay_time += 3;
                if (this.pay_time >= 60) {
                    this.pay_time = 0;
                    clearInterval(this.timer);
                    this.timerout = true;
                }
            }, 3000)
        },
        toLogion() {
            console.log(111)
            this.LogionSwitch = !this.LogionSwitch
            if (!this.LogionSwitch) {
                clearInterval(this.timer)
            }
            if (!this.isWeixin && this.LogionSwitch) {
                this.get_login_code()
            }
        },
        getRefundMoney() {
            let res = 0
            let sevePay = this.reqFundInfo.vip_use_day >= 7 ? this.reqFundInfo.vip_use_day * 1.5 : 0
            res = this.reqFundInfo.pay_money / 100 - sevePay - this.reqFundInfo.use_num * 5
            return res >= 0 ? res * 100 : 0
        },
        toKF() {
            utils.tokf()
            // window.open('/linkus')
        },

        getRefundInfo() {
            this.$http.get('/front/aivideo/refund/', { id: localStorage.getItem('user_id') }).then(res => {
                if (res.status == 200) {
                    if (Object.keys(res.data) == 0) {
                        this.reqrePopBoxshow = true
                        this.xiyi = false
                        this.nullOrder = true
                    } else {
                        this.nullOrder = false
                        this.reqFundInfo = res.data
                        if (res.data.refund_req_time != 0) {//已有退款记录
                            this.reqrePopBoxshow = true
                            this.isReqStatu = true
                            this.isSuccess = false
                            this.xiyi = false
                        } else {

                            if (res.data.refund_time != 0) {
                                this.reqrePopBoxshow = true
                                this.isReqStatu = true
                                this.isSuccess = true
                                this.xiyi = false
                            } else {
                                this.reqrePopBoxshow = true
                                this.isReqStatu = false
                                this.isSuccess = false
                                this.xiyi = true
                            }
                        }
                    }
                }
                // if(this.reqFundInfo.refund_req_time!=0){//已有退款记录
                //     this.reqrePopBoxshow = true
                //     this.isReqStatu = true
                //     this.isSuccess = false
                //     this.xiyi = false
                // }else{

                //     if(this.reqFundInfo.refund_time!=0){
                //         this.reqrePopBoxshow = true
                //         this.isReqStatu = true
                //         this.isSuccess = true
                //         this.xiyi = false
                //     }else{
                //         this.reqrePopBoxshow = true
                //         this.isReqStatu = false
                //         this.isSuccess = false
                //         this.xiyi = true
                //     }
                // }


            }).catch(err => {
                // if (err.status == 200) {
                //     this.reqrePopBoxshow = true
                //     this.xiyi = false
                //     if (err.message == "未找到订单") {
                //         this.nullOrder = true
                //     } else {
                //         this.nullOrder = false
                //     }
                //     if(err.message == "nologin"){
                //         this.$store.state.show_login_compoments = true
                //     }
                // }else{
                //     this.$message.error(err)
                // }
                // if(this.reqFundInfo.refund_req_time!=0){//已有退款记录
                //     this.reqrePopBoxshow = true
                //     this.isReqStatu = true
                //     this.isSuccess = false
                //     this.xiyi = false
                // }else{

                //     if(this.reqFundInfo.refund_time!=0){
                //         this.reqrePopBoxshow = true
                //         this.isReqStatu = true
                //         this.isSuccess = true
                //         this.xiyi = false
                //     }else{
                //         this.reqrePopBoxshow = true
                //         this.isReqStatu = false
                //         this.isSuccess = false
                //         this.xiyi = true
                //     }
                // }
            })
        },
        formatTimestamp(timestamp) {
            // 处理时间戳单位（兼容秒和毫秒）
            if (timestamp < 1e12) timestamp *= 1000;

            const date = new Date(timestamp);

            // 获取日期组件
            const year = date.getFullYear();
            const month = date.getMonth() + 1; // 月份从0开始需+1
            const day = date.getDate();

            // 获取时间组件并补零
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            // 组合成目标格式
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        checkXieye() {
            //如果没有退款弹出协议
            if (isReq.value) {
                this.reqrePopBoxshow = true
                this.xiyi = true
            } else {
                this.reqrePopBoxshow = false
                this.xiyi = false
            }
        },

        guide() {
            // getRefundInfo()
            if (this.nullOrder) {
                this.reqrePopBoxshow = true
                //打开暂无订单弹框
                this.isReqStatu = false
                this.xiyi = false
            } else {
                this.reqrePopBoxshow = false
                this.xiyi = false
            }
        },

        //申请退款
        toReqreFun() {
            let tok = localStorage.getItem('token')
            if (!tok) {
                this.$store.state.show_login_compoments = true
                return
            }
            if (!this.reqFundInfo.pay_money) {
                this.$store.state.show_login_compoments = true
                return
            }
            if (!this.reqreText.trim().length) {
                this.$message.error("请填写退款原因!")
                return
            }
            // if(!this.reqFundInfo.vip_use_day){
            //     this.$message.error("请先开通会员!")
            //     return
            // }
            this.$http.post('/front/aivideo/refund/', { id: this.reqFundInfo.id, refund_money: this.getRefundMoney(), refund_remark: this.reqreText }).then(res => {
                if (res.status == 200) {
                    this.reqrePopBoxshow = true
                    this.isReqStatu = true
                    this.isSuccess = true
                    this.reqFundInfo.refund_req_time = res.data.refund_req_time
                    this.xiyi = false
                }
            })
        },
        closePop() {
            this.reqrePopBoxshow = false
            location.href = '/'
        }
    }

}
</script>

<style lang="scss" scoped>
.reqrefundBox {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;

    &::-webkit-scrollbar {
        display: none;
    }

    // overflow: hidden;
    .reqrefundTit {
        font-size: 36px;
        color: #000;
        padding-top: 30px;

    }

    .reqrefundTitTip {
        font-size: 16px;
        color: #9a9a9a;
        margin-top: 20px;
        white-space: nowrap;
    }

    .reqrefundInfo {
        width: calc(100% - 40px);
        margin-top: 40px;

        .infoItem {
            display: flex;
            // align-items: center;
            margin-bottom: 25px;


            .ItemTit {
                font-size: 16px;
                color: #000;
                white-space: nowrap;
            }

            .reqreTextare {
                border: 1px solid #e5e5e5;
                width: 100%;
                // text-indent: 0.5em;
                padding: 5px;
                min-height: 100px;
                border-radius: 6px;
                color: #ccc;

                ::placeholder {
                    color: #ccc !important;
                }
            }

            .itemTex {
                font-size: 18px;
                color: #000;
                white-space: nowrap;

                .resText {
                    font-size: 30px;
                    color: #ff0000;
                }

                .resOth {
                    font-size: 16px;
                }
            }

            .itemTexOne {
                color: #ff0000;
            }

            .itemTexTwoOth {
                color: #cfcfcf;
                font-size: 18px;
                white-space: nowrap;
            }

            .itemTexTwo {
                color: #4bb74b;
                white-space: nowrap;

                .itemTip {
                    margin-left: 5px;
                }
            }

            .itemTexThr {
                color: #1212ff;
            }

            .infoLfet {
                display: flex;
                align-items: center;

                .itemBt {
                    padding: 8px 10px;
                    background: #000;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: 600;
                }
            }

            .inforght {
                font-size: 16px;
                color: #000;
            }
        }

        .intoIemOth {
            align-items: baseline;
        }

        .infoOne {
            justify-content: space-between;
            align-items: center;
        }

        .infoThr {
            align-items: baseline;
        }

        .infoTwo {
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }

        .seveText {
            color: #cfcfcf;
            font-size: 16px;
            margin-bottom: 35px;
        }
    }

    .reqreBtn {
        background: #000;
        border-radius: 6px;
        width: calc(100% - 40px);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        line-height: 66px;
    }

    .reqTipText {
        font-size: 16px;
        color: #cfcfcf;
        margin-top: 20px;
        white-space: nowrap;
    }

    .reqTimeBox {
        width: calc(100% - 40px);
        background: #ececec;
        margin-top: 40px;
        color: #000;
        padding: 20px;
        line-height: 26px;
        font-size: 16px;
        border-radius: 6px;

        .quBottom {
            margin: 10px 0;
        }

        .anText {
            color: #666;
        }

    }
}

.reqrePopBox {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, .9);

    .reqSuccessBox {
        width: calc(100% - 20px);
        height: 400px;
        background: #fff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 50px;
        position: relative;

        .noOrderText {
            color: #cfcfcf;
        }

        .reqSuccessImg {
            width: 30px;
            height: 30px;
        }

        .reqSucText {
            font-size: 18px;
            color: #33a954;
            margin-top: 30px;
        }

        .reqSucTextOth {
            color: #ff0000;
        }

        .reqSucTip {
            color: #cfcfcf;
            margin-top: 40px;
        }

        .closeBtn {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #000;
            color: #fff;
            border-radius: 6px;
            width: calc(100% - 30px);
            padding: 15px 0;
            position: absolute;
            bottom: 20px;
        }

        .logTit {
            font-size: 20px;
            color: #000;
        }

        .saoImg {
            width: 150px;
            height: 150px;
            margin: 20px 0;
        }

        .loginTipTex {
            color: #000;
            font-size: 16px;
        }

        .loginTipTexOth {
            margin: 20px 0;
        }

        .loginTipTexBlu {
            color: #0066ff;
        }
    }

    .reqSuccessBoxOth {
        height: 470px;

        .noOrderBox {
            width: 91%;
            display: flex;
            flex-direction: column;
            margin: 0 auto;
            margin-top: 20px;

            .noOrderText {
                margin: 10px 0;
                line-height: 30px;
            }
        }
    }

    .instructions_box {
        width: calc(100% - 60px);
        background-color: #fff;
        border-radius: 8px;
        color: #000;
        padding: 26px 16px 2px;
        font-size: 14px;

        p {
            text-align: center;
            font-weight: 700;
            font-size: 18px;
            margin-bottom: 20px;
        }

        div {
            font-size: 16px;
            margin-bottom: 16px;
        }

        .subBtn1 {
            width: 100%;
            height: 50px;
            background: #000;
            color: #fff;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            // margin-bottom: 0;
        }
    }

    .color_11 {
        color: #0000ff;
    }

    .ft_i2 {
        font-size: 16px;
        text-indent: 2em;
        line-height: 32px;
    }

    .color_r {        color: #ff0000;
    }
}
.LoginPanel {
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 400px;
    width: calc(100% - 20px);
    color: #000;
    position: relative;

    .closeChechLogin {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 20px;
        height: 20px;
        z-index: 10;
        cursor: pointer;
    }

    .LoginBox {
        width: 100%;
        //   height: 400px;
        background: #fff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 50px;
        position: relative;


        .logTit {
            font-size: 20px;
            color: #000;
        }

        .saoImg {
            width: 150px;
            height: 150px;
            margin: 20px 0 0;
        }

        .time_out_cover {
            position: absolute;
            top: 20px;
            left: 0;
            width: 150px;
            height: 150px;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.58);
            color: #fff;
            font-size: 12px;
            z-index: 10;

            &:hover {
                font-size: 16px;
                font-weight: bold;
            }

            display: flex;
            align-items: center;
            justify-content: center;
        }

        .account,
        .cipher {
            input {
                width: 255px;
                height: 40px;
                padding: 4px;
                border: 1px solid #c0c4cc;
                border-radius: 5px;
                font-size: 14px;
            }

            input::placeholder {
                font-size: 14px;
                /* 设置占位符字体大小 */
                color: #999;
                /* 可以同时设置占位符的颜色 */
            }
        }

        .account {
            input {
                margin: 30px 0 15px;
            }
        }

        .cipher {
            input {
                margin: 15px 0 30px;
            }
        }

        .loginBtn {
            width: 255px;
            height: 40px;
            background-color: black;
            color: #fff;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
        }

        .loginTipTexOths {
            margin-bottom: 20px;
        }

        .loginTipTex {
            color: #000;
            font-size: 16px;
        }

        .LoginOth {
            margin: 20px 0;
        }

        .LoginBlu {
            cursor: pointer;
            color: #0066ff;
            margin-bottom: 10px;
        }
    }
}
</style>
